import React, {useCallback, useEffect, useRef, useState} from 'react';
import {any, arrayOf, func, node, string} from 'prop-types';
import PhoneInput from 'react-phone-number-input';
import If from '../../misc/If';
import PhoneNumberService from '../../../service/PhoneNumberService';

import 'react-phone-number-input/style.css';
import './PhoneNumberInput.css';

const propTypes = {
  className    : string,
  errors       : arrayOf(node),
  label        : node,
  onChange     : func,
  onPressEnter : func,
  value        : any
};

const defaultProps = {
  className    : '',
  errors       : [],
  label        : null,
  onChange     : () => null,
  onPressEnter : () => null,
  value        : null
};

const DEFAULT_COUNTRY = 'US';

function PhoneNumberInput(props) {
  const {errors, label, onChange, onPressEnter, value} = props;
  const inputRef = useRef(null);
  const [country, setCountry] = useState(DEFAULT_COUNTRY);
  const [placeholder, setPlaceholder] = useState(PhoneNumberService.getExampleNumber(DEFAULT_COUNTRY, true));

  useEffect(() => {
    if (typeof inputRef.current?.focus === 'function') {
      inputRef.current.focus();
    }
  }, []);

  const onCountryChange = useCallback(newCountry => {
    if (newCountry) {
      setCountry(newCountry);
    }
  }, []);

  const onKeyDown = useCallback(event => {
    if (event.keyCode === 13) {
      onPressEnter(event);
    }
  }, [onPressEnter]);

  useEffect(() => {
    if (country) {
      const newPlaceholder = PhoneNumberService.getExampleNumber(country, true);

      setPlaceholder(newPlaceholder);
    }
  }, [country]);

  return (
    <div className="phone-number-input__wrap">
      <If condition={Boolean(label)}>
        <label className="phone-number-input__label">
          {label}
        </label>
      </If>

      <div className="phone-number-input__input-wrap">
        <PhoneInput
          className="phone-number-input"
          country={country}
          defaultCountry={country}
          flagUrl="https://flag.pk/flags/4x3/{xx}.svg"
          onCountryChange={onCountryChange}
          placeholder={placeholder}
          ref={inputRef}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
      </div>

      <If condition={errors.length > 0}>
        <p className="phone-number-input__error">
          {errors[0]}
        </p>
      </If>
      <If condition={errors.length === 0}>
        <p className="phone-number-input__error_hidden">
          error
        </p>
      </If>
    </div>
  );
}

PhoneNumberInput.propTypes = propTypes;
PhoneNumberInput.defaultProps = defaultProps;

export default PhoneNumberInput;
